import { Signal, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { AccountFeatureService } from 'src/app/services/account-feature/account-feature.service';
import { CallStoreService } from 'src/app/pages/learner/call/library/call-store/call-store.service';
import { selectMessageForLanguages } from 'src/app/utils/account-feature-message.util';

// The "This is an AI avatar" notice shown with the avatar: the sim's language first, then the
// learner's browser language, then English; null when there is nothing to show.
// Call from a component's field initializer.
export function injectAiNotice(): Signal<string | null> {
  // Every message the account has set up, one per language; empty until the request returns.
  const messages = toSignal(inject(AccountFeatureService).getAiNoticeMessages(), { initialValue: [] });
  // The sim's language is set once the call starts, so the notice updates when it arrives.
  const callStore = inject(CallStoreService);
  // Picks the sim's language, then the browser's, then English.
  return computed(() => selectMessageForLanguages(messages(), [callStore.getLanguage(), navigator.language]));
}
